import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { CheckCircleOutline, ErrorOutline, Refresh } from '@material-ui/icons';

export interface StatusDivProps {
  status: string;
  text: string;
  onRefresh?: () => void;
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '16px',
    borderRadius: 8,
  },
  IN_PROGRESS: {
    backgroundColor: '#FFFBEB',
    border: '1px solid #F59E0B',
    color: '#92400E',
  },
  SUCCESS: {
    backgroundColor: '#F0FDF4',
    border: '1px solid #86EFAC',
    color: '#166534',
  },
  FAILED: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FCA5A5',
    color: '#991B1B',
  },
  icon: {
    flexShrink: 0,
    fontSize: '1.1rem',
    color: 'inherit',
  },
  text: {
    fontWeight: 700,
    fontSize: '0.875rem',
    color: 'inherit',
    flex: 1,
  },
  refreshButton: {
    width: '100px',
  },
});

const statusIcons: Record<string, (className: string) => JSX.Element> = {
  IN_PROGRESS: (className) => <></>,
  SUCCESS: (className) => <CheckCircleOutline className={className} />,
  FAILED: (className) => <ErrorOutline className={className} />,
  FLAGGED: (className) => <ErrorOutline className={className} />,
};

// statuses that render as another one
const statusAliases: Record<string, string> = {
  FLAGGED: 'FAILED',
};

export const StatusDiv = ({ status, text, onRefresh }: StatusDivProps) => {
  const classes = useStyles();
  const styleKey = statusAliases[status] ?? status;
  const renderIcon = statusIcons[status] ?? statusIcons[styleKey];

  return (
    <Box className={`${classes.container} ${classes[styleKey as keyof typeof classes] ?? ''}`}>
      {renderIcon?.(classes.icon)}
      <Typography className={classes.text}>{text}</Typography>
      {styleKey === 'IN_PROGRESS' && onRefresh && (
        <Button
          variant="text"
          color="inherit"
          className={classes.refreshButton}
          onClick={onRefresh}
          startIcon={<Refresh />}
        >
          Refresh
        </Button>
      )}
    </Box>
  );
};
